import { useState, useEffect } from "react";
import { ApiUrl } from "../../ApiUrl";


const useFetchBookCategories = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchBookCategories = async () => {
      const apiURL = `${ApiUrl.apiurl}BookCategory/GetAllBookCategoryList/`;
      try {
        const response = await fetch(apiURL);
        const result = await response.json();
        if (response.ok) {
          const rawCategories = Array.isArray(result?.data) ? result.data : [];
          const formattedData = rawCategories.map((category) => ({
            id: category.id,
            name: category.CategoryName,
            description: category.categoryDescription,
            branchName: category.branchName,
            isActive: category.is_active,
          }));
          setCategories(formattedData);
        }
      } catch (err) {
        // Silently handle errors by leaving categories empty
        console.error("Error fetching book categories:", err);
      }
    };
    fetchBookCategories();
  }, []);

  return { categories };
};

export default useFetchBookCategories;
